// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host ::ng-deep .conversion__block .p-accordion-tab .p-accordion-header-link,
:host ::ng-deep .conversion__block .p-accordion-tab .p-accordion-content {
  transition: background-color 0.6s linear;
  background: transparent;
}
:host ::ng-deep .conversion__block-title:after {
  content: "";
  position: absolute;
  width: calc(var(--width) + 2.5rem);
  left: -1.25rem;
  height: 4px;
  bottom: -1.25rem;
  background: linear-gradient(167deg, #844b92, #d49a20);
}

.screenshot-container {
  height: 534px;
  z-index: 1;
}
.screenshot-container > * {
  background-color: #131313;
  background-repeat: no-repeat;
  background-size: cover;
  border-radius: 4px;
  height: 534px;
  z-index: 1;
  object-fit: cover;
  transition: transform 0.4s ease-in-out;
}
.screenshot-container > *.mobile-screenshot {
  margin-right: -40px;
}

:host ::ng-deep .conversion__block.open-features .p-accordion-tab .p-accordion-content {
  background: var(--color-block) !important;
}
:host ::ng-deep .conversion__block.open-features .p-accordion-tab .p-accordion-header-link {
  background: var(--color-header) !important;
}

.screenshot-container > video {
  box-shadow: 0 0 16px 0 var(--color-block), 0 0px 16px 0 var(--color-block);
}

[data-index="0"] {
  --color-block: #af7217;
  --color-header: rgb(99, 72, 16);
}

[data-index="1"] {
  --color-block: rgb(15, 104, 145);
  --color-header: rgb(15, 60, 90);
}

[data-index="2"] {
  --color-block: rgb(158, 151, 165);
  --color-header: rgb(60, 60, 60);
}

@media only screen and (max-width: 1199px) {
  :host ::ng-deep .p-accordion p-accordiontab:first-child .p-accordion-header-link {
    border-radius: 6px 6px 0 0;
  }
  :host ::ng-deep .p-accordion p-accordiontab:not(:first-child) .p-accordion-header-link {
    border-radius: 0;
  }
  :host ::ng-deep .p-accordion p-accordiontab:not(:last-child) .p-accordion-content {
    border-radius: 0;
  }
  :host ::ng-deep .p-accordion p-accordiontab .p-accordion-tab {
    margin-bottom: 0;
  }
  :host ::ng-deep h4 {
    margin-right: 0;
    font-size: 16px;
    line-height: 23px;
    margin-bottom: 0;
    padding-right: 40px;
  }
  :host ::ng-deep .feature-text p {
    font-size: 14px;
    line-height: 23px;
    padding-right: 40px;
  }
  :host ::ng-deep .screenshot.mobile-screenshot {
    margin-right: -20px;
    border-radius: 10px;
    object-fit: cover;
    margin-right: -40px;
    box-shadow: initial;
  }
}`, "",{"version":3,"sources":["webpack://./src/app/modules/home/components/conversion/conversion.component.scss"],"names":[],"mappings":"AAOE;;EAEE,wCAAA;EACA,uBAAA;AANJ;AAUI;EACE,WAAA;EACA,kBAAA;EACA,kCAAA;EACA,cAAA;EACA,WAAA;EACA,gBAAA;EACA,qDAAA;AARN;;AAaA;EACE,aAAA;EACA,UAAA;AAVF;AAYE;EACE,yBAAA;EACA,4BAAA;EACA,sBAAA;EACA,kBAAA;EACA,aAAA;EACA,UAAA;EACA,iBAAA;EACA,sCAAA;AAVJ;AAYI;EACE,mBAAA;AAVN;;AAgBE;EACE,yCAAA;AAbJ;AAgBE;EACE,0CAAA;AAdJ;;AAkBA;EACE,0EAAA;AAfF;;AAkBA;EACE,sBAAA;EACA,+BAAA;AAfF;;AAkBA;EACE,gCAAA;EACA,+BAAA;AAfF;;AAkBA;EACE,iCAAA;EACA,+BAAA;AAfF;;AAxDE;EA4EE;IACE,0BAAA;EAhBJ;EAmBE;IACE,gBAAA;EAjBJ;EAoBE;IACE,gBAAA;EAlBJ;EAqBE;IACE,gBAAA;EAnBJ;EAsBE;IACE,eAAA;IACA,eAAA;IACA,iBAAA;IACA,gBAAA;IACA,mBAAA;EApBJ;EAwBI;IACE,eAAA;IACA,iBAAA;IACA,mBAAA;EAtBN;EA0BE;IACE,mBAAA;IACA,mBAAA;IACA,iBAAA;IACA,mBAAA;IACA,mBAAA;EAxBJ;AACF","sourcesContent":["@mixin md() {\r\n  @media only screen and (max-width: 1199px) {\r\n    @content;\r\n  }\r\n}\r\n\r\n:host ::ng-deep {\r\n  .conversion__block .p-accordion-tab .p-accordion-header-link,\r\n  .conversion__block .p-accordion-tab .p-accordion-content {\r\n    transition: background-color 0.6s linear;\r\n    background: transparent;\r\n  }\r\n\r\n  .conversion__block-title {\r\n    &:after {\r\n      content: \"\";\r\n      position: absolute;\r\n      width: calc(var(--width) + 2.5rem);\r\n      left: -1.25rem;\r\n      height: 4px;\r\n      bottom: -1.25rem;\r\n      background: linear-gradient(167deg, #844b92, #d49a20);\r\n    }\r\n  }\r\n}\r\n\r\n.screenshot-container {\r\n  height: 534px;\r\n  z-index: 1;\r\n\r\n  > * {\r\n    background-color: #131313;\r\n    background-repeat: no-repeat;\r\n    background-size: cover;\r\n    border-radius: 4px;\r\n    height: 534px;\r\n    z-index: 1;\r\n    object-fit: cover;\r\n    transition: transform 0.4s ease-in-out;\r\n\r\n    &.mobile-screenshot {\r\n      margin-right: -40px;\r\n    }\r\n  }\r\n}\r\n\r\n:host ::ng-deep {\r\n  .conversion__block.open-features .p-accordion-tab .p-accordion-content {\r\n    background: var(--color-block) !important;\r\n  }\r\n\r\n  .conversion__block.open-features .p-accordion-tab .p-accordion-header-link {\r\n    background: var(--color-header) !important;\r\n  }\r\n}\r\n\r\n.screenshot-container > video {\r\n  box-shadow: 0 0 16px 0 var(--color-block), 0 0px 16px 0 var(--color-block);\r\n}\r\n\r\n[data-index=\"0\"] {\r\n  --color-block: #af7217;\r\n  --color-header: rgb(99, 72, 16);\r\n}\r\n\r\n[data-index=\"1\"] {\r\n  --color-block: rgb(15, 104, 145);\r\n  --color-header: rgb(15, 60, 90);\r\n}\r\n\r\n[data-index=\"2\"] {\r\n  --color-block: rgb(158, 151, 165);\r\n  --color-header: rgb(60, 60, 60);\r\n}\r\n\r\n:host ::ng-deep {\r\n  @include md() {\r\n    .p-accordion p-accordiontab:first-child .p-accordion-header-link {\r\n      border-radius: 6px 6px 0 0;\r\n    }\r\n\r\n    .p-accordion p-accordiontab:not(:first-child) .p-accordion-header-link {\r\n      border-radius: 0;\r\n    }\r\n\r\n    .p-accordion p-accordiontab:not(:last-child) .p-accordion-content {\r\n      border-radius: 0;\r\n    }\r\n\r\n    .p-accordion p-accordiontab .p-accordion-tab {\r\n      margin-bottom: 0;\r\n    }\r\n\r\n    h4 {\r\n      margin-right: 0;\r\n      font-size: 16px;\r\n      line-height: 23px;\r\n      margin-bottom: 0;\r\n      padding-right: 40px;\r\n    }\r\n\r\n    .feature-text {\r\n      p {\r\n        font-size: 14px;\r\n        line-height: 23px;\r\n        padding-right: 40px;\r\n      }\r\n    }\r\n\r\n    .screenshot.mobile-screenshot {\r\n      margin-right: -20px;\r\n      border-radius: 10px;\r\n      object-fit: cover;\r\n      margin-right: -40px;\r\n      box-shadow: initial;\r\n    }\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
